import client from 'app/client';
import { AddressDto, OperationResponse } from 'api/actor';

/** Mode de connexion d'une plateforme (Codes.ModesConnexionPlateforme côté back). */
export type ConnectionMode = 'STANDARD' | 'SSO_PARTENAIRE';

/** Fiche corporate d'une plateforme (onglet Informations). */
export interface CorporateDto {
  personneMoraleId: string;
  name: string;
  /** CodeEntreprise (clé SSO). */
  code: string;
  /** Mode de connexion : STANDARD ou SSO_PARTENAIRE (adhérents connectés par le SSO du partenaire). */
  connectionMode: ConnectionMode;
  /** SIREN (9 chiffres). */
  registrationNumber: string;
  capital: number;
  rcsCity: string;
  rcsNumber: string;
  oriasNumber?: string | null;
  rcp?: string | null;
  /** Code nature de la PM (CRT, CIE…) — résout le profil de briques. */
  nature?: string | null;
  /** Code sous-nature (GRO, MUT…). */
  sousNature?: string | null;
  /** Libellé de la nature de la PM (ex. « Cabinet de courtage »). */
  natureLabel?: string | null;
  /** Libellé de la sous-nature de la PM. */
  sousNatureLabel?: string | null;
  phone: string;
  email: string;
  address?: AddressDto | null;
  /** Rôles métier attribuables (liste blanche serveur). */
  assignableRoles: string[];
  /** Rôles métier actuellement attribués. */
  assignedRoles: string[];
}

export interface UpdateCorporateInfoCommand {
  name: string;
  /** CodeEntreprise (clé SSO). Requis, unicité vérifiée serveur. */
  code: string;
  /** Requis. SSO_PARTENAIRE exige un code entreprise non vide. */
  connectionMode: ConnectionMode;
  address?: AddressDto;
  phone: string;
  registrationNumber: string;
  capital: number;
  rcsCity: string;
  rcsNumber: string;
  oriasNumber: string;
  rcp?: string | null;
  email: string;
}

export async function getCorporate(plateformeId: string): Promise<CorporateDto> {
  const { data } = await client.get<CorporateDto>(
    `/backoffice/plateformes/${plateformeId}/corporate`,
  );
  return data;
}

export async function updateCorporate(
  plateformeId: string,
  command: UpdateCorporateInfoCommand,
): Promise<OperationResponse> {
  const { data } = await client.put<OperationResponse>(
    `/backoffice/plateformes/${plateformeId}/corporate`,
    command,
  );
  return data;
}

export async function updateCorporateRoles(
  plateformeId: string,
  roles: string[],
): Promise<OperationResponse> {
  const { data } = await client.put<OperationResponse>(
    `/backoffice/plateformes/${plateformeId}/corporate/roles`,
    { roles },
  );
  return data;
}
